export class Category {
  id: string;
  description: string;
}